import store from "../../../Store";
import { toggleURLQuery } from "../../../helpers/UrlHelper";
import getRoles from "../../../ajax/actions/role/roles_get";

export function toggleRoleListFilter(e) {
  return function (dispatch) {
    let { name, value } = e.target;
    dispatch({ type: "TOGGLE-ROLE-LIST-FILTER", name, value });
    store.dispatch(getRoles(true));
  };
}

export function setDefaultRoleFiltersToURL(history) {
  return (dispatch, getState) => {
    let { data } = getState().siteList;
    let { params } = data;
    Object.keys(params).map((key) => {
      if (
        params[key] !== `` &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        toggleURLQuery(key, params[key], history);
      }
    });
  };
}

export function resetRolesParams() {
  return (dispatch) => {
    dispatch({ type: "TOGGLE-RESET-ROLES" });
  };
}
